import { openBlock, createElementBlock } from 'vue';

const _hoisted_1 = {
  ref: "arrowRef",
  class: "el-popper__arrow",
  "data-popper-arrow": ""
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("span", _hoisted_1, null, 512);
}

export { render };
//# sourceMappingURL=arrow.vue_vue_type_template_id_8ab40b80_lang.mjs.map
